
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import OeamtcIcon, { IconProps } from '@components/new-styleguide/icon/OeamtcIcon.vue';
import IconAdd from '@components/icons/icon-add.svg';

export interface OeamtcSelectValue {
  name: string,
  tagIcon?: IconProps,
  letterIcon?: IconProps
}

@Component({
  name: 'OeamtcSelect',
  components: {
    OeamtcIcon,
    IconAdd
  },
})
export default class OeamtcSelect extends Vue {
  @Prop()
  private value: number;

  @Prop({ required: true })
  private options: OeamtcSelectValue[];

  @Prop({ required: true })
  private ariaName: string;

  @Prop()
  private emptySelectText: string;

  @Prop({ default: false })
  private disabled: boolean;

  @Prop()
  private addPageRouteName: string;

  @Prop()
  private tripId: string;

  @Prop({ default: false })
  private smallBox: boolean;

  private isOpen = false;

  created() {
    document.addEventListener('mousedown', this.closeOutside);
  }

  destroyed() {
    document.removeEventListener('mousedown', this.closeOutside);
  }

  get addRoute() {
    return { name: this.addPageRouteName, query: { tripId: this.tripId } };
  }

  private closeOutside(evt) {
    if (!this.$el.contains(evt.target)) {
      this.close();
    }
  }

  private toggleSelect() {
    this.isOpen = !this.isOpen;
  }

  private select(option: number) {
    this.close();
    this.$emit('input', option);
  }

  private onArrowDown() {
    if (this.value < this.options.length - 1) {
      this.$emit('input', this.value + 1);
    } else if (this.value == this.options.length - 1) {
      this.$emit('input', 0);
    }
  }

  private onArrowUp() {
    if (this.value > 0) {
      this.$emit('input', this.value - 1);
    } else if (this.value == 0 && this.options.length > 1) {
      this.$emit('input', this.options.length - 1);
    }
  }

  private close() {
    this.isOpen = false;
  }
}
